import { render, staticRenderFns } from "./DomainChip.vue?vue&type=template&id=27f3f93e&scoped=true&"
import script from "./DomainChip.vue?vue&type=script&lang=ts&"
export * from "./DomainChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f3f93e",
  null
  
)

export default component.exports